// we should not log any analytics during tests
export default {
  logPageView () {},
  logAction () {},
  setUserDimension () {},
  logTime () {}
};
